import React, { memo, useEffect } from 'react';
import { Platform, Text } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import { FontDecorationToken, FontTransformToken, TextAlignTokens, FontFamilyTokens, } from '@voltmoney/schema';
import { isFromTDLPlatform } from '../pages/utils';
/**
 * Raw Component with Derived props + Theme
 */
const TypographyBase = ({ id, label = 'Lorem ipsum dolor sit amet', color, fontSize, fontFamily = FontFamilyTokens.Inter, fontWeight = '400', textDecorationLine = FontDecorationToken.none, textTransform = FontTransformToken.none, textAlign = TextAlignTokens.auto, ellipsizeMode, numberOfLines = 0, lineHeight = 0, marginRight, ...props }) => {
    useEffect(() => {
        if (Platform.OS === 'web')
            if (isFromTDLPlatform())
                loadFont();
    });
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const fontFamilyMapping = theme.fontFamily;
    const fontSizeMapping = theme.fontSize;
    const applyFontFamilyWithWeightRN = Platform.OS === 'web'
        ? isFromTDLPlatform() ? fontFamily === FontFamilyTokens.Inter ? 'InterSimonson' : 'MyCustomFont' : fontFamilyMapping[fontFamily]
        : `${fontFamilyMapping[fontFamily]}${parseFontWeightRN(fontWeight)}`;
    const loadFont = () => {
        const fontUrl = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/simonsonBold.otf';
        const fontFace = new FontFace('MyCustomFont', `url(${fontUrl})`);
        const interSimonson = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/simonsonRegular.otf';
        const interSimonsonFontFace = new FontFace('InterSimonson', `url(${interSimonson})`);
        fontFace.load().then((loadedFontFace) => {
            document.fonts.add(loadedFontFace);
        }).catch((error) => {
            console.error('Failed to load font:', error);
        });
        interSimonsonFontFace.load().then((loadedFontFace) => {
            document.fonts.add(loadedFontFace);
        }).catch((error) => {
            console.error('Failed to load font:', error);
        });
    };
    if (!label)
        return React.createElement(React.Fragment, null);
    else
        return (React.createElement(Text, { nativeID: id, style: [
                {
                    fontFamily: applyFontFamilyWithWeightRN,
                    fontWeight: fontWeight,
                    color: colorMapping[color],
                    fontSize: fontSizeMapping[fontSize],
                    textTransform: textTransform,
                    textDecorationLine: textDecorationLine,
                    textAlign: textAlign,
                    padding: 0,
                    marginRight: marginRight,
                },
                lineHeight > 0 ? { lineHeight } : {},
            ], ...props, numberOfLines: numberOfLines }, label));
};
export default memo(TypographyBase);
export { TypographyBase };
const parseFontWeightRN = (size) => {
    switch (size) {
        case '100':
        case '200':
        case '300':
            return '-Light';
        case '400':
            return '-Regular';
        case '500':
            return '-SemiBold';
        case '600':
        case '700':
            return '-Bold';
        case '800':
            return '-ExtraBold';
        default:
            return '-Regular';
    }
};
